import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseEmptyExpenseNameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.empty-expense-name-error.message');
    }
}
